import React from 'react';
import { uspsProfessional } from '../data/mockData';
import * as Icons from 'lucide-react';

const ProfessionalAssistanceSection = () => {
  return (
    <section className="py-24 bg-[#F4F4F5]" data-testid="professional-section">
      <div className="container mx-auto px-6 lg:px-16">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <p className="text-xs uppercase tracking-[0.2em] font-bold text-zinc-500 mb-3">Full Service</p>
          <h2 className="text-2xl sm:text-3xl font-bold tracking-tight text-[#09090B]" style={{fontFamily:'Outfit,sans-serif'}}>
            More Than Filing. Complete Brand Protection.
          </h2>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-px bg-zinc-200 rounded-lg overflow-hidden">
          {uspsProfessional.map((usp) => {
            const IconComponent = Icons[usp.icon];
            return (
              <div key={usp.id} className="bento-hover bg-white p-8" data-testid={`professional-card-${usp.id}`}>
                <div className="w-10 h-10 bg-[#002FA7] rounded-md flex items-center justify-center mb-4">
                  {IconComponent && <IconComponent className="w-5 h-5 text-white" />}
                </div>
                <h3 className="text-base font-bold text-[#09090B] mb-2" style={{fontFamily:'Outfit,sans-serif'}}>{usp.title}</h3>
                <p className="text-sm text-zinc-500 leading-relaxed">{usp.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ProfessionalAssistanceSection;
